import { prop } from 'ramda';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSocketSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';

import { toggleReconnectVisible } from 'js/components/system/App/store/actions';

export const useAppNotifier = () => {
    const dispatch = useDispatch();
    const connected = useSocketSelector(prop('connected'));
    const [online, setOnline] = useState(true);
    const prevConnected = usePrevious(connected);

    useEffect(() => {
        const handleOnline = () => setOnline(true);
        const handleOffline = () => setOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    useEffect(() => {
        dispatch(toggleReconnectVisible(!connected && prevConnected || !online));

        if (!connected && prevConnected || !online) {
            window.Playtech.API && window.Playtech.API.popup.showPopup('confirmation', {
                closeAll: true,
                title: 'playtech.mobile.system.message.reconnect',
                acceptBtnText: 'playtech.mobile.system.button.reconnect',
                declineBtnText: 'playtech.mobile.system.message.close',
                onAccept: () => window.location.reload(),
                isModal: false,
                className: 'reconnect-popup'
            });
        }

    }, [
        dispatch,
        online,
        connected,
        prevConnected
    ]);
};
